// extracted by mini-css-extract-plugin
export default {"comment_box":"index_comment_box_S-IMO","title":"index_title_d-ydf","bg_box":"index_bg_box_WlRss","counts":"index_counts_JQH5t"};